<template lang="pug">
  div.calendar-wrapper
    div.calendar-title
      div.change-month.month-add(@click="minusMonth") <
      div.year-month-info {{year}} - {{ month }}
      div.change-month.month-minus(@click="addMonth") >
    div.calendar
      div.calendar-head
        div.week-title--text(v-for="title in weekTitle") {{ title }}
      div.calendar-content-week(v-for="week, weekInd in monthMatrix")
        div.calendar-content-days(v-for="day, dayInd in week" :class="{ 'avaliable': day !== undefined, 'unavaliable': day === undefined }")
          div.calendar-content-text(v-if="day === undefined") X
          div.calendar-content-text(v-else @click="selectDay(weekInd, dayInd)" :class="{ 'selected-day': dayInd === selectDayInd && weekInd === selectWeekInd,  }") {{day}}


</template>

<script>
import Vue from 'vue';
import moment from 'moment';


export default {
  name: 'Calendar',
  data() {
    return {
      weekTitle: [
        'Sun', 'Mon', 'Tue', 'Wen', 'Thu', 'Fri', 'Sat',
      ],
      year: null,
      month: null,
      date: null,
      selectWeekInd: null,
      selectDayInd: null,
      dateSelected: null,
      momentNow: null,
      todayWeekCount: 0,
      todayWeekDay: 0,
    };
  },
  created() {
    this.momentNow = moment();
    this.setData(this.momentNow);
    this.creatMonthMatrix(this.year, this.month);
    this.selectDay(this.todayWeekCount, this.todayWeekDay);
  },
  methods: {
    setData(momentData) {
      // this.momentNow = momentData;
      this.year = momentData.year();
      this.month = momentData.month() + 1;
      this.date = momentData.date();
    },
    addMonth() {
      this.setData(this.momentNow.add(1, 'months'));
      this.creatMonthMatrix();
    },
    minusMonth() {
      this.setData(this.momentNow.subtract(1, 'months'));
      this.creatMonthMatrix();
    },
    selectDay(weekInd, dayInd) {
      this.selectWeekInd = weekInd;
      this.selectDayInd = dayInd;
      this.dateSelected = this.monthMatrix[weekInd][dayInd];
      this.$emit('setDatetime', `${this.year}-${this.month}-${this.dateSelected}`);
    },
    creatMonthMatrix() {
      const numberOfDaysThisMonth = moment(`${this.year}-${this.month}`, 'YYYY-MM').daysInMonth();
      const numberOfDaysPreviousMonth = moment(`${this.year}-${this.month}`, 'YYYY-MM').subtract(1, 'months').daysInMonth();
      /* eslint-disable */
      const calendarMatrix = new Array(Array(7), Array(7), Array(7), Array(7), Array(7), Array(7));
      const start = moment(`${this.year}-${this.month}-01`, 'YYYY-MM-DD').days();
      for (let i = 1; i < numberOfDaysThisMonth + 1; i += 1) {
        const weekday = (i + start - 1) % 7; // shift the start day
        const weekCount = Math.floor((i + start - 1) / 7);
        calendarMatrix[weekCount][weekday] = i;
        if (i === this.momentNow.date()) {
          this.todayWeekCount = weekCount;
          this.todayWeekDay = weekday;
        }
      }
      this.monthMatrix = calendarMatrix;
    },
  },
};
</script>

<style lang="sass">
.calendar
  display: table
  .calendar-head, .calendar-content-week
    display: table-row
  .calendar-content-days, .week-title--text
    display: table-cell
    .calendar-content-text
      height: 40px;
      width: 40px;
      justify-content: center
      align-items: center
      text-align: center;
      display: flex
    .calendar-content-text-disabled
      color: transparent
  .week-title--text
    border-bottom: 1px solid rgba(0,0,0,0.3)
    text-align: center
  
.avaliable
  &:hover
    background-color: rgba(0,0,0,0.1)
.unavaliable
  .calendar-content-text
    color: transparent

.calendar-wrapper
  width: 300px
  display: flex;
  justify-content: center;
  flex-direction: column;

.selected-day
  background-color: red
  color: white
  border-radius: 50%

.calendar-title
  display: flex
  justify-content: space-between
  margin-bottom: 10px

.change-month
  background: cadetblue
  color: white
  padding: 2px 10px

.year-month-info
  display: flex;
  justify-content: center;
  align-items: center;
  color: cadetblue;
  font-weight: 800;
  
</style>



// WEBPACK FOOTER //
// Calendar.vue?e6ea7dae